<template>
  <div v-if="currentConfig">
    <el-row>
      <el-col :span="5" v-if="!isDialog">房间号</el-col>
      <el-col :span="19">
        <el-input
          ref="roomUrlInput"
          placeholder="请输入房间号"
          v-model.trim="currentConfig.global.liveRoomUrl"
          @blur="checkRoomUrl()"
          class="room-id-input"
        >
          <el-button slot="prepend">
            <i
              :class="currentConfig.global.liveRoomName_config ? '' : 'fa-eye'"
            ></i>
            {{ currentConfig.global.liveRoomName_config }}
          </el-button>
          <el-button
            slot="append"
            icon="fa-folder-open-o"
            @click="openLiveRoom(currentConfig.global.liveRoomUrl)"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getRoomName, getConfig, updateConfig } from "@/api/index";
import { mapState } from "vuex";
let inputRoomUrlTimer = null;
export default {
  data() {
    return {
      currentConfig: null,
      // 检查房间号相关
      isInputCheckAfter: false,
      isFirstLoading: true,
    };
  },
  computed: {
    ...mapState({
      video: (state) => state.video,
      isPC: (state) => state.isPC,
      isWeixin: (state) => state.isWeixin,
      isElectron: (state) => state.isElectron,
      robotList: (state) => state.robotList,
      user: (state) => state.user,
      guideType: (state) => state.guideType,
    }),
  },
  props: {
    isCloud: {
      type: Boolean,
      default: true,
    },
    configure: {
      type: Object,
      default: null,
    },
    currentConfigCopy: {
      type: String,
      default: "",
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    ticket: {
      type: String,
      default: "",
    },
  },
  watch: {
    "currentConfig.global.liveRoomUrl": {
      handler: function(val, oldVal) {
        if (this.isFirstLoading) {
          this.isFirstLoading = false;
          return;
        }
        if (inputRoomUrlTimer) {
          clearTimeout(inputRoomUrlTimer);
          inputRoomUrlTimer = null;
        }
        inputRoomUrlTimer = setTimeout(() => {
          this.checkRoomUrl(true);
        }, 15e2);
      },
    },
  },
  mounted() {
    if (this.configure) {
      this.currentConfig = this.configure;
      if (
        !this.currentConfig.global.liveRoomName_config &&
        this.currentConfig.global.liveRoomUrl
      ) {
        this.checkRoomUrl();
      }
    }
    if (this.ticket && !this.configure) {
      this.getConfig(this.ticket);
    }
  },
  methods: {
    checkRoomUrl(inputAfter) {
      console.log(inputAfter);
      if (inputRoomUrlTimer) {
        clearTimeout(inputRoomUrlTimer);
        inputRoomUrlTimer = null;
      }
      if (!this.currentConfig.global.liveRoomUrl) {
        this.currentConfig.global.liveRoomName_config = "";
        localStorage.roomId = "";
        return;
      }
      if (this.isInputCheckAfter) {
        this.isInputCheckAfter = false;
        return;
      }
      //检查房间号是否为推流地址
      if (/^rtmp:/i.test(this.currentConfig.global.liveRoomUrl)) {
        this.$message.warning("请输入房间号，不是推流地址");
        this.currentConfig.global.liveRoomUrl = "";
      }
      if (/huya.com/i.test(this.currentConfig.global.liveRoomUrl)) {
        let urlArray = this.currentConfig.global.liveRoomUrl.split("huya.com/");
        this.currentConfig.global.liveRoomUrl = urlArray[urlArray.length - 1];
        if (/\?/i.test(this.currentConfig.global.liveRoomUrl)) {
          let urlArray = this.currentConfig.global.liveRoomUrl.split("?");
          this.currentConfig.global.liveRoomUrl = urlArray[0];
        }
      }
      getRoomName(
        {
          roomId:
            this.currentConfig.global.liveRoomUrl ||
            this.currentConfig.cloud.liveRoomUrl,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          this.currentConfig.global.liveRoomName_config = res.data;
          if (
            this.currentConfigCopy &&
            this.currentConfig.global.liveRoomUrl !==
              JSON.parse(this.currentConfigCopy).global.liveRoomUrl
          ) {
            if (
              this.currentConfig.signIn.enable &&
              this.currentConfig.signIn.listLength
            ) {
              if (inputAfter) return;
              this.$confirm("切换房间后，原打卡记录将清除", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.$message({
                    dangerouslyUseHTMLString: true,
                    message:
                      '换了新房间，记得检查下「<a href="#anchorNick">主播昵称</a>」哦',
                    type: "warning",
                  });
                  this.currentConfig.cloud.liveRoomUrl = this.currentConfig.global.liveRoomUrl;
                  this.$emit("roomChange");
                })
                .catch(() => {
                  this.currentConfig.global.liveRoomUrl = JSON.parse(
                    this.currentConfigCopy
                  ).global.liveRoomUrl;
                });
            } else {
              this.$message({
                dangerouslyUseHTMLString: true,
                message:
                  '换了新房间，记得检查下「<a href="#anchorNick">主播昵称</a>」哦',
                type: "warning",
              });
              this.currentConfig.cloud.liveRoomUrl = this.currentConfig.global.liveRoomUrl;
              this.save();
            }
            if (inputAfter) {
              // this.isInputCheckAfter = true;
            }
          }
        } else {
          if (res.code == 500) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>找不到这个主播</strong><p style="margin-top: 5px;">请确认房间号是否正确</p>',
            });
          }
          this.currentConfig.global.liveRoomName_config = "无此房间";
        }
        this.currentConfig.cloud.liveRoomUrl = this.currentConfig.global.liveRoomUrl;
        localStorage.roomId = this.currentConfig.global.liveRoomUrl;
      });
    },
    getConfig(ticket) {
      getConfig(
        {
          ticket: ticket,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          const currentConfig = res.data.configure;
          let d = JSON.parse(currentConfig);
          if (this.currentConfig == null) {
            this.currentConfig = d;
          } else {
            Object.assign(this.currentConfig, d);
          }
        }
      });
    },
    save() {
      let isShowAIChatMes = false;
      this.currentConfig.AIChat.symbolList.forEach((inputValue) => {
        if (
          !!~inputValue.indexOf("/{") ||
          !!~inputValue.indexOf("{") ||
          !!~inputValue.indexOf("/")
        ) {
          isShowAIChatMes = true;
        }
      });
      if (isShowAIChatMes) {
        return this.$message({
          showClose: true,
          message: "互动符号不能含有'/'或'{'符号",
          type: "error",
        });
      }
      if (
        (!this.currentConfig.global.liveRoomName_config &&
          this.currentConfig.global.liveRoomUrl) ||
        (this.currentConfig.global.liveRoomName_config &&
          !this.currentConfig.global.liveRoomUrl) ||
        (this.currentConfig.global.liveRoomName_config &&
          this.currentConfig.global.liveRoomUrl &&
          this.currentConfig.global.liveRoomName_config == "无此房间")
      ) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>信息不完整</strong><p style="margin-top: 5px;">请确认房间号或房间名是否正确</p>',
        });
        return;
      }
      updateConfig({
        configure: JSON.stringify(this.currentConfig),
        ticket: this.ticket,
      }).then((res) => {
        if (res.code == 0) {
          this.$emit("saveCompleted");
        }
      });
    }, // 保存配置
    async openLiveRoom(roomurl) {
      let accountList = localStorage["accountList"]
        ? JSON.parse(localStorage["accountList"])
        : {};
      if (roomurl) {
        if (
          (this.isElectron && !this.isCloud) ||
          (this.isElectron && this.isCloud && this.configure.readText.enable)
        ) {
          const res = await manager.showLocalRobot(this.ticket);
          if (res.code != 0) {
            this.$message({
              title: "提示",
              message: res.message,
              type: "error",
              duration: 2000,
            });
          }
        } else {
          let url = `https://www.huya.com/${roomurl}`;
          if (this.isElectron) {
            url = `${url}${
              accountList[this.ticket] && accountList[this.ticket].cookies
                ? `?cookies=${encodeURIComponent(
                    accountList[this.ticket].cookies
                  )}`
                : ""
            }`;
          }
          window.open(url);
        }
      } else {
        this.$message({
          title: "提示",
          message: "请填写房间号",
          type: "error",
          duration: 2000,
        });
      }
    },
    roomUrlInputFocus() {
      this.$refs.roomUrlInput.focus();
    },
  },
};
</script>
